// Func = limiting Scope for this file
var lastScrollTop = 0;

// var BookBox = document.getElementById('bookBox');

//datepicker booking
var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');
var opencheck = 0;
var firstClick = 0;

//resize sizes
var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;
resizeWindow();

(function(){

	//menu gallery
	menuLinksInteraction();

	//close
	let allClose = document.getElementsByClassName('close-js');
	for(let i =0; i < allClose.length; i++){
		allClose[i].addEventListener('click', function(){
			let section = this.parentElement.parentElement;
			section.classList.remove('open');
		})
	}
	//menu open
	document.getElementsByClassName('cta-js')[0].addEventListener('click', function(){
		document.getElementsByClassName('navigation-js')[0].classList.add('open');
	})

	//booking cta show
	document.getElementsByClassName('js-booking-cta')[0].addEventListener('click', function(){
		if(!document.getElementById('bookingBox').classList.contains('open')){
			document.getElementById('bookingBox').classList.add('open');
			this.innerHTML = 'Close';
			document.getElementById('bookingBox').addEventListener('click', checkOutBooking);
		} else {
			document.getElementById('bookingBox').classList.remove('open');
			this.innerHTML = 'Reserve';
			document.getElementById('bookingBox').removeEventListener('click', checkOutBooking);
		}
	});
	document.getElementById('closeBooking').addEventListener('click', function(){
		document.getElementById('bookingBox').classList.remove('open');
		document.getElementsByClassName('js-booking-cta')[0].innerHTML = 'Reserve';	
	});


	$(document).ready(function () {

		//To create after event 
		//let checkInOut = document.getElementById('check_in_out');
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}
		$('#arriveInput').on('change', function(){
			start = $(this).val();
			$('.calendar-block').datepicker("setDate", start)
		})
		$('#departureInput').on('change', function(){
			end = $(this).val();
			$('.calendar-block').datepicker("setDate", end)
		})

		$('.calendar-block').datepicker({
			changeMonth: true,
			dateFormat: 'yy-mm-dd',
			//minDate: '2021-05-07',
			numberOfMonths: 1,
			monthNamesShort : [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
			beforeShowDay: function (date) {
				$.datepicker._defaults.dateFormat = "yy-mm-dd";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
					opencheck = 0;
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}					
				}
				$('#check_in_out').attr('value', start + '  /  ' + end);
				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);
			
			},
			onChangeMonthYear: function () {
				//opencheck = 1;
			}
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		
		
	});

	window.onload = function() {
		if(document.getElementById('home')){
			if(windowWidth > 600){
				scrollW();
				window.addEventListener('scroll', function(){
					scrollW();
				})
			} else {
				document.getElementById('header').classList.add('down');
				window.addEventListener('scroll', function(){
					scrollMobile();
				})
			}
		} else {
			document.getElementById('header').classList.add('down');
			window.addEventListener('scroll', function(){
				scrollW();
			})
		}
		resizeWindow();
		window.addEventListener('resize', function(){
			resizeWindow();
		});
	};

	//SVG titles

	const svg_titles = document.getElementsByClassName('svg-title');
	for(let i = 0; i < svg_titles.length; i++){
		const this_span = svg_titles[i].querySelector('span');
		const thisText = this_span.innerHTML;

		this_span.innerHTML = 	'<svg width="650" height="100" viewbox="0 0 650 110" xmlns="http://www.w3.org/2000/svg">'+
								'<text x="50%" y="105" text-anchor="middle">'+thisText+'</text>'+
								'</svg>';
	}


	
	$( ".map-block__dots .pin" ).removeClass('open');
	$( ".map-block__items li" ).addClass(' hidden');
	$( ".generic-link" ).hide();
	$( ".map-filter__selector li a" ).on( "click", function(){

		$( ".generic-link" ).show();
		if($(".map-filter__selector li a").hasClass('active')){
			$(".map-filter__selector li a").removeClass('active')
			
		}

		$(this).addClass('active');
		$( ".map-block__dots .pin" ).removeClass('open');
		$( ".map-block__dots .pin." + $( this ).attr( "data-target" )).addClass('open');
		$( ".map-block__items li" ).addClass(' hidden');
		$( ".map-block__items li." + $( this ).attr( "data-target" )).show().addClass('open');

		if( $( ".map-block__items li:visible" ).eq( 0 ).data( "haslink" ) != "1" ){
			$( ".generic-link" ).hide();
		}	

		$( ".generic-link" ).attr( "href", $( ".map-block__items li:visible" ).eq( 0 ).data( "link" ) )

        return false;
	} );

	
}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
			// if(!document.getElementById('bookBox').classList.contains('down')){
			// 	document.getElementById('bookBox').classList.add('down');
			// 	document.getElementById('bookBox').classList.remove('up');
			// }
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function resizeWindow(){
	//calculate a new window size
	windowWidth = w.innerWidth||e.clientWidth||g.clientWidth;
	windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

	//header image to be window height on homepage
	if(document.getElementsByClassName('big-image').length > 0){
		
		let headerImages = document.getElementsByClassName('big-image');
		let headerImagesLength = headerImages.length;
		for(let i = 0; i < headerImagesLength; i++){
			if(document.getElementById('home')){
				headerImages[i].style.height = (windowHeight + 5) + 'px';
			} else {
				headerImages[i].style.height = '500px';
			}
		}
		
	}
	
	if(windowWidth < 1000){
		document.getElementById('primary-nav').classList.add('tablet-view');
	}
	
}

function menuLinksInteraction(){
	if(document.getElementsByClassName('menu-gallery__item').length > 0){
		//ini
		let ini = 0;
		let allPrimaryA = document.getElementById('primary-nav').getElementsByTagName('a');
		let allGalleryI = document.getElementsByClassName('menu-gallery__item');
		for(let i = 0;i < allPrimaryA.length; i++ ){
			if(allPrimaryA[i].classList.contains('active')){
				allGalleryI[i].classList.add('active');
				ini = 1;
			}
		}
		if(ini == 0){
			allGalleryI[0].classList.add('active');
		} 
		//hover
		for(let i = 0;i < allPrimaryA.length; i++ ){
			allPrimaryA[i].addEventListener('mouseenter', function(e){
				for(let j = 0;j < allGalleryI.length; j++){
					allGalleryI[j].classList.remove('active')
				}
				allGalleryI[i].classList.add('active')
			})
		}
	}
	
}

// GROUPS TOGGLE
document.querySelectorAll('.corporate-quad__title').forEach((btn, i) => {
	btn.addEventListener('click', _ => {
	document.querySelectorAll('.corporate-quad__title').forEach(b => b.parentNode.classList.remove('active'));
	btn.parentNode.classList.add('active');
	document.querySelectorAll('.corporate-quad__image .image, .corporate-quad__text').forEach(item => { 
		item.classList.remove('active'); 
		if ( btn.dataset.id === item.dataset.id ) { item.classList.add('active'); } });
	}); 
	if (i === 0) btn.click(); 
});

const showMoreBtn = document.getElementsByClassName('show-more')[0];

if(showMoreBtn){
	showMoreBtn.addEventListener('click', _=>{
		document.querySelectorAll('.columns-content__item.hide,.press-block__item.hide').forEach(item =>{
			item.classList.remove('hide');
			showMoreBtn.classList.add('hide');
		})
	});
}

//click event for booking
function checkOutBooking(e){
	let parentBooking = document.getElementById('bookingBox');
	if(e.target == parentBooking){
		document.getElementById('bookingBox').classList.remove('open');
		document.getElementsByClassName('js-booking-cta')[0].innerHTML = 'Reserve';	
	}
}


$( ".activities-filter__selector li a" ).on( "click", function(){
	if($(".activities-filter__selector li a").hasClass('active')){
		$(".activities-filter__selector li a").removeClass('active')
		
	}  
	$(this).addClass('active');
	$( ".activities-content__item" ).hide();
	$( ".activities-content__item." + $( this ).attr( "data-target" )  ).show();

	return false;
} );
